import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile, isWideScreen } from "../../../@css-style";

export const ElContactUsLite = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 4em 0;
  padding-top: 0;
  background-repeat: no-repeat;
  background-position: right;
  ${isMobile} {
    padding: 2em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElContactUsLiteContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  padding: 10px;
  align-items: center;
  justify-content: center;
  /* background-color: #fff; */
  ${isMobile} {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const ElColumn = styled.div<{ "data-color"?: string }>`
  width: 100%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* gap: 20px; */
`;

export const ElColumnInside = styled.div`
  width: 25%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  overflow: hidden;
  position: relative;

  ${String(isMobile)} {
    max-width: 100% !important;
    width: 100% !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: auto;
  }
  ${String(isWideScreen)} {
    max-width: 50%;
    width: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: auto;
  }
`;

export const ElHeaderSubTitle = styled.h3`
  color: #003562;

  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; /* 25px */
  letter-spacing: -0.4px;
`;

export const ElBoxSubs = styled.a`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 20px;
  &:hover {
    opacity: 0.6;
  }
`;

export const ElBoxSubsInside = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 5px;
`;

export const ElDetails = styled.p`
  color: #003562;

  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; /* 17.5px */
  letter-spacing: -0.28px;
`;

export const elGapContactUsLite = css`
  gap: 20px;
`;

export const elPad20 = css`
  padding: 20px;
  gap: 20px;
`;
